function initChromaReveal( el ) {
	const observer = new window.IntersectionObserver(
		( entries ) => {
			for ( const entry of entries ) {
				if ( entry.isIntersecting ) {
					// Swap, don't stack — see src/product-value/view.js.
					el.classList.remove( 'text-grey-100' );
					el.classList.add( 'chroma-text', 'chroma-sweep-animate' );
					observer.disconnect();
					break;
				}
			}
		},
		{ threshold: 0.4 }
	);
	observer.observe( el );
}

function initStageObserver( root ) {
	const stages = root.querySelectorAll( '.how-it-works-stage' );
	if ( stages.length === 0 ) {
		return;
	}

	const observer = new window.IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				entry.target.classList.toggle(
					'is-in-view',
					entry.isIntersecting
				);
			} );
		},
		{ threshold: 0.3 }
	);

	stages.forEach( ( stage ) => observer.observe( stage ) );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.how-it-works-reveal' )
		.forEach( initChromaReveal );
	document
		.querySelectorAll( '.wp-block-avoid-content-how-it-works' )
		.forEach( initStageObserver );
} );
